import { registerSW } from 'virtual:pwa-register';

if ('serviceWorker' in navigator) {
    const updateSW = registerSW({
        immediate: true,
        onRegisteredSW(_swUrl, registration) {
            if (!registration) {
                return;
            }

            // Check for updates every half an hour
            setInterval(
                () => {
                    registration.update();
                },
                5 * 60 * 1000,
            );

            // Check for updates when the page becomes visible
            document.addEventListener('visibilitychange', () => {
                if (document.visibilityState === 'visible') {
                    registration.update();
                }
            });
        },
        onNeedRefresh() {
            updateSW(true);
        },
    });
}
